export interface PopoverProps {
	workfileId: string;
}
